// src/components/Navbar.js
import React from 'react';
import { Navbar, Nav, Button } from 'react-bootstrap';

const navbar = () => {
  return (
    <Navbar bg="light" expand="lg">
      <div className="container-fluid">
        <Navbar.Brand href="#home"><span className='logo-color'>ARETE</span> Talent Pool Management</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto d-flex justify-content-end w-100">
            <Button variant="outline-primary" className="m-2">Request Document</Button>
            <Button variant="outline-primary" className="m-2">Match to Position</Button>
            <Button variant="primary m-2">Add Candidate</Button>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
};

export default navbar;
